module.exports = __webpack_public_path__ + "img/matrix_3.2ed31186.png";